<template>
  <b-notification :closable="false">
    {{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-1') }}
    <a
      target="_blank"
      class="link"
      href="https://ecoinfo.cnrs.fr/ecodiag-calcul"
      >Ecodiag</a
    >
    {{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-2') }}
    <a target="_blank" class="link" href="https://ecoinfo.cnrs.fr">EcoInfo</a>
    {{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-3') }}
    {{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-4') }}
    <em>{{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-5') }}</em
    >.
    <br />
    {{ $t('compCarbonFormsDevicesHelpCalculatingMethod.text-6') }}
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
